const initialState = {
  treatmentPageTrack: null,
};

export default (state = Object.assign({}, initialState), { type, payload }) => {
  switch (type) {
    case "treatementPageTrack":
      return {
        ...state,
        treatmentPageTrack: payload,
      };

    default:
      return state;
  }
};
